import React from "react";
import Reveal from "@/components/Reveal";
import { UserRoundCheck, Compass, Handshake, Rocket } from "lucide-react";

const cards = [
 { icon: UserRoundCheck, title: "Personal guidance", text: "Every First-Time Founder starts with a real conversation, not a form. We understand your business first." },
 { icon: Compass, title: "Founder-first advice", text: "We recommend structures that fit your funding plans, co-founders and risk profile not what earns us more." },
 { icon: Handshake, title: "Support beyond paperwork", text: "GST, MSME, ROC filings, first invoice, first bank account we stay with you long after incorporation." },
 { icon: Rocket, title: "Launch readiness", text: "Domain, email, website, brand basics and Google Business everything you need to look serious from day one." },
];

export const Differentiation = () => (
 <section className="bg-[#F8F9FA] border-y border-[#EAEAEA]" data-testid="differentiation-section">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
 <Reveal>
 <div className="max-w-2xl">
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 Our difference
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
 We are not a <span className="hl-yellow">registration factory</span>.
 </h2>
 <p className="mt-5 text-[16px] md:text-[17px] text-[#1C1F26] leading-relaxed">
 Starting a business is one of the most important first-time
 decisions in a person's life. That is why we focus on guidance,
 trust and practical handholding not just paperwork.
 </p>
 </div>
 </Reveal>

 <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
 {cards.map((c, i) => {
 const Icon = c.icon;
 return (
 <Reveal delay={i * 80} key={c.title}>
 <div className="group h-full bg-white border border-[#EAEAEA] rounded-2xl p-7 relative overflow-hidden hover:shadow-[0_8px_30px_rgb(0,0,0,0.05)] transition-shadow flex flex-col items-center text-center">
 <div className="absolute top-0 left-0 h-1 w-0 bg-[#FDD805] group-hover:w-full transition-[width] duration-500" />
 <div className="w-12 h-12 rounded-full bg-[#FDD805] flex items-center justify-center">
 <Icon size={20} className="text-[#0F1115]" />
 </div>
 <h3 className="mt-5 font-display text-[20px] font-bold text-[#0F1115]">
 {c.title}
 </h3>
 <p className="mt-2 text-[14.5px] leading-relaxed text-[#1C1F26]">
 {c.text}
 </p>
 </div>
 </Reveal>
 );
 })}
 </div>
 </div>
 </section>
);

export default Differentiation;
